import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/botoks-sonrasi-alkol-tuketimi-bilimsel-aciklamalar-klinik-etkiler-ve-uzman-onerileri/page.tsx");
